import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { CommonService } from './common.service';
import { UserService } from './user.service';

import { User } from '../models/user';
import { mergeMap, catchError, map } from 'rxjs/operators';
import { HttpClient,HttpHeaders } from '@angular/common/http';

declare var sessionStorage: any;

export type UserEventType = 'login' | 'logout';

export interface UserChangeEvent {
    type: UserEventType;
    user: User;
}

class DefaultUserChangeEvent implements UserChangeEvent {
    type: UserEventType;
    user: User;

    constructor(type, user) {
        this.type = type;
        this.user = user;
    }
}

@Injectable()
export class AuthService {

    onUserChange: EventEmitter<UserChangeEvent> = new EventEmitter<UserChangeEvent>();

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService,
        private userService: UserService) { }


    public authenticate(username: string, password: string): Observable<User> {

        let body = JSON.stringify({ 'username': username, 'password': password });
        const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});

        return this.httpClient.post(environment.API_END_POINT + '/users/self/tokens', body, { headers: headers })
            .pipe(
                mergeMap(response => {
                    this.commonService.setCurrentToken((<any>response).token);
                    return this.userService.getSelf()
                        .pipe(
                            map(user => {
                                this.commonService.setCurrentUser(user);
                                this.onUserChange.emit(new DefaultUserChangeEvent('login', this.cloneUser(user)));
                                return user;
                            })
                        );
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    forgetPassword(userEmail: string):Observable<Boolean> {
        let body = JSON.stringify({ 'email': userEmail });
        const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
        return this.httpClient.post(environment.API_END_POINT+'/users/forgetPassword',body,{ headers: headers}).pipe(
          map(response => true),
          catchError((error: Response | any) => this.commonService.handleHttpError(error))
        );;
    }
    public logout(): void {
        this.httpClient.delete(environment.API_END_POINT + '/users/self/tokens', { headers: this.commonService.getHeaders() }).subscribe();
        sessionStorage.clear();
        this.onUserChange.emit(new DefaultUserChangeEvent('logout', null));
    }

    public isLoggedIn(): boolean {
        if (this.commonService.getCurrentToken() == null || this.commonService.getCurrentToken().trim() === '') {
            return false;
        } else {
            return true;
        }
    }

    private cloneUser(user: User): User {
        return <User>JSON.parse(JSON.stringify(user));
    }

}
